"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.evtIsDarkModeEnabled = exports.useIsDarkModeEnabled = void 0;
var useGlobalState_1 = require("powerhooks/useGlobalState");
var urlSearchParams_1 = require("powerhooks/tools/urlSearchParams");
var _a = useGlobalState_1.createUseGlobalState({
    "name": "isDarkModeEnabled",
    "initialState": window.matchMedia &&
        window.matchMedia("(prefers-color-scheme: dark)").matches,
    "doPersistAcrossReloads": true,
}), useIsDarkModeEnabled = _a.useIsDarkModeEnabled, evtIsDarkModeEnabled_needsAnnotation = _a.evtIsDarkModeEnabled;
exports.useIsDarkModeEnabled = useIsDarkModeEnabled;
exports.evtIsDarkModeEnabled = evtIsDarkModeEnabled_needsAnnotation;
(function () {
    var result = urlSearchParams_1.retrieveParamFromUrl({
        "url": window.location.href,
        "name": "theme",
    });
    if (!result.wasPresent) {
        return;
    }
    urlSearchParams_1.updateSearchBarUrl(result.newUrl);
    var isDarkModeEnabled = (function () {
        switch (result.value) {
            case "dark":
                return true;
            case "light":
                return false;
            default:
                return undefined;
        }
    })();
    if (isDarkModeEnabled === undefined) {
        return;
    }
    exports.evtIsDarkModeEnabled.state = isDarkModeEnabled;
})();
exports.evtIsDarkModeEnabled.attach(function (isDarkModeEnabled) {
    var id = "root-color-scheme";
    remove_existing_element: {
        var element_1 = document.getElementById(id);
        if (element_1 === null) {
            break remove_existing_element;
        }
        element_1.remove();
    }
    var element = document.createElement("style");
    element.id = id;
    element.innerHTML = "\n\t\t\t\t:root {\n\t\t\t\t\tcolor-scheme: " + (isDarkModeEnabled ? "dark" : "light") + "\n\t\t\t\t}\n\t\t";
    document.getElementsByTagName("head")[0].appendChild(element);
});
//# sourceMappingURL=useIsDarkModeEnabled.js.map